export enum BriefingTypeEnum {
    IDENTIDADE_VISUAL = 'IDENTIDADE VISUAL',
    WEBSITE = 'WEBSITE',
    REGISTER_CUSTOMERS = 'CADASTRO DO CLIENTE',
    REGISTER_PARTNERS = 'CADASTRO DE PARCEIRO'
  }
  
  export enum BriefingTypeIdEnum {
    'IDENTIDADE_VISUAL' = 1,
    'WEBSITE' = 2,
    'REGISTER_CUSTOMERS' = 3,
    'REGISTER_PARTNERS' = 4
  }
  
  export function getBriefingTypeDescriptionByValue(value: number): string {
    const entries = Object.entries(BriefingTypeIdEnum);
    const [key] = entries.find(([_, enumValue]) => enumValue === value) || [];
    return BriefingTypeEnum[key as keyof typeof BriefingTypeEnum] || '';
  }

  export const briefingTypeOptions = Object.keys(BriefingTypeEnum).map(key => ({
    label: BriefingTypeEnum[key as keyof typeof BriefingTypeEnum],
    value: BriefingTypeIdEnum[key as keyof typeof BriefingTypeIdEnum]
  }));

  
  
  